var config = {
    onPremise        : true,
    loginKeycloack   : true
}

export default config